import { Configuration, DriveApi, type ConfigurationParameters } from '@teemill/drive';
import type { App } from 'vue';

export let client: DriveApi;
export let errorHandler: (e: any) => void;

export const drive = {
  install(
    app: App,
    options: {
      client: ConfigurationParameters;
      errorHandler: (e: any) => void;
    },
  ) {
    client = new DriveApi(
      new Configuration({
        ...options.client,
        baseOptions: {
          headers: {
            'User-Agent': null,
          },
        },
      }),
    );
    errorHandler = options.errorHandler || ((e) => console.error(e));
  },
};
